// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3Ykck","left":"StickyBox_left__LK_Nx","right":"StickyBox_right__3aafT"};